// Updated Footer.js - Minimal: Simple text, no italics, clean link
import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => (
  <footer className="bg-ehh-navy text-ehh-peach py-6 text-center text-sm">
    <p>&copy; 2025 EMA House of Hope. All rights reserved.</p>
    <p className="mt-2">Designed by <a href="https://fugipay.com/" target="_blank" rel="noopener noreferrer" className="text-ehh-orange hover:underline">FugiPay</a></p>
  </footer>
);

export default Footer;